import Vue from 'vue'
import thebox from '../util/thebox.util'
import yqzResource from '~/resource'
import QuotationDialog from '~/components/Base/QuotationDialog'

Vue.prototype.$_newtab = '_self'
if (process.client) {
  if (thebox.clientWidth > 940) {
    Vue.prototype.$_newtab = '_blank'
  }
}
Vue.prototype.$_thebox = thebox

Vue.component('QuotationDialog', QuotationDialog)
Vue.prototype.defaultCompanyLogo = yqzResource.defaultImg.company
Vue.prototype.defaultProjectImg = yqzResource.defaultImg.project
Vue.prototype.$_yqzResource = yqzResource
